import { createContext, useContext } from 'react';
import type { RuntimeEventConfig } from '@/shared/config/approval.mapping';

/**
 * Contexto em arquivo próprio, separado do provider, pelo mesmo motivo do
 * `auth-context`: quem só consome o hook não importa o componente.
 */
export const EventConfigContext = createContext<RuntimeEventConfig | null>(null);

/**
 * Parametrização do evento vinda da API.
 *
 * Garantida: o provider só renderiza os filhos depois de carregar. Colunas,
 * abas e trilhas do painel saem daqui — nenhum ID nem rótulo é fixo no código.
 */
export function useEventConfig(): RuntimeEventConfig {
  const context = useContext(EventConfigContext);
  if (!context) {
    throw new Error('useEventConfig deve ser usado dentro de <EventConfigProvider>.');
  }
  return context;
}
